(() => {
  const q = (root, sel) => root.querySelector(sel);
  const qa = (root, sel) => Array.from(root.querySelectorAll(sel));

  // Mount controls into .carousel__controls if present, otherwise into the viewport/root
  const mount = (root) =>
    q(root, ".carousel__controls") || q(root, ".carousel__viewport") || root;

  function buildDots(root, count) {
    let dots = q(root, ".carousel__dots");
    const m = mount(root);

    // Create dots container if missing
    if (!dots) {
      dots = document.createElement("div");
      dots.className = "carousel__dots";
      dots.setAttribute("role", "tablist");
      m.appendChild(dots);
    } else if (dots.parentElement !== m) {
      // Ensure dots live inside the mount container (fixes weird ordering)
      m.appendChild(dots);
    }

    dots.innerHTML = "";
    for (let i = 0; i < count; i++) {
      const b = document.createElement("button");
      b.className = "carousel__dot";
      b.type = "button";
      b.setAttribute("role", "tab");
      b.setAttribute("aria-label", `Go to slide ${i + 1}`);
      b.dataset.carouselDot = String(i);
      b.setAttribute("aria-selected", i === 0 ? "true" : "false");
      dots.appendChild(b);
    }

    return qa(root, ".carousel__dot");
  }

  function initCarousel(root) {
    if (!root || root.dataset.carouselInit === "1") return;
    root.dataset.carouselInit = "1";

    const track = q(root, ".carousel__track");
    const slides = qa(root, ".carousel__slide");
    if (!track || slides.length === 0) return;

    const m = mount(root);

    // Ensure arrows exist, and enforce DOM order: prev -> dots -> next
    let prev = q(root, ".carousel__arrow--prev");
    if (!prev) {
      prev = document.createElement("button");
      prev.className = "carousel__arrow carousel__arrow--prev";
      prev.type = "button";
      prev.setAttribute("aria-label", "Previous");
      prev.innerHTML = "<span aria-hidden='true'>‹</span>";
    }
    if (prev.parentElement !== m) m.appendChild(prev);

    // Build dots immediately after prev so they land between arrows
    const dots = buildDots(root, slides.length);

    let next = q(root, ".carousel__arrow--next");
    if (!next) {
      next = document.createElement("button");
      next.className = "carousel__arrow carousel__arrow--next";
      next.type = "button";
      next.setAttribute("aria-label", "Next");
      next.innerHTML = "<span aria-hidden='true'>›</span>";
    }
    if (next.parentElement !== m) m.appendChild(next);

    // Re-enforce final order if anything pre-existed in a weird spot
    m.appendChild(prev);
    const dotsWrap = q(root, ".carousel__dots");
    if (dotsWrap) m.appendChild(dotsWrap);
    m.appendChild(next);

    let i = 0;

    const setDots = (n) =>
      dots.forEach((d, idx) =>
        d.setAttribute("aria-selected", idx === n ? "true" : "false")
      );

    const go = (n) => {
      i = (n + slides.length) % slides.length;
      track.style.transform = `translateX(-${i * 100}%)`;
      setDots(i);
    };

    // If only 1 slide, hide controls and exit
    if (slides.length < 2) {
      prev.style.display = "none";
      next.style.display = "none";
      if (dotsWrap) dotsWrap.style.display = "none";
      go(0);
      return;
    }

    // Prevent duplicate listeners if Shopify re-inits
    if (root.dataset.carouselWired !== "1") {
      root.dataset.carouselWired = "1";

      prev.addEventListener("click", (e) => {
        e.stopPropagation();
        go(i - 1);
      });

      next.addEventListener("click", (e) => {
        e.stopPropagation();
        go(i + 1);
      });

      dots.forEach((d) =>
        d.addEventListener("click", (e) => {
          e.stopPropagation();
          go(parseInt(d.dataset.carouselDot, 10) || 0);
        })
      );

      // Swipe / drag
      const viewport = q(root, ".carousel__viewport") || root;
      const isUI = (el) =>
        !!(el && el.closest && el.closest(".carousel__arrow, .carousel__dot"));

      let down = false,
        startX = 0,
        dx = 0;

      const downFn = (x) => {
        down = true;
        startX = x;
        dx = 0;
      };
      const moveFn = (x) => {
        if (!down) return;
        dx = x - startX;
      };
      const upFn = () => {
        if (!down) return;
        down = false;
        if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1));
      };

      viewport.addEventListener("pointerdown", (e) => {
        if (isUI(e.target)) return;
        try {
          viewport.setPointerCapture(e.pointerId);
        } catch (_) {}
        downFn(e.clientX);
      });
      viewport.addEventListener("pointermove", (e) => moveFn(e.clientX));
      viewport.addEventListener("pointerup", upFn);
      viewport.addEventListener("pointercancel", upFn);
      viewport.addEventListener("pointerleave", upFn);

      // Touch fallback
      let touchStartX = null;
      viewport.addEventListener(
        "touchstart",
        (e) => {
          if (isUI(e.target)) return;
          touchStartX = e.touches[0].clientX;
        },
        { passive: true }
      );

      viewport.addEventListener(
        "touchend",
        (e) => {
          if (touchStartX === null) return;
          const endX = e.changedTouches[0].clientX;
          const d = endX - touchStartX;
          if (Math.abs(d) > 40) go(i + (d < 0 ? 1 : -1));
          touchStartX = null;
        },
        { passive: true }
      );

      // Keyboard
      root.tabIndex = 0;
      root.addEventListener("keydown", (e) => {
        if (e.key === "ArrowLeft") go(i - 1);
        if (e.key === "ArrowRight") go(i + 1);
      });
    }

    go(0);
  }

  function initAll() {
    document.querySelectorAll("[data-carousel]").forEach(initCarousel);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", initAll);
})();



